import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_PROJECT_INTEGRATION_CLUEY',
  name: 'Workspace Project Cluey Integration',
  type: 'PROJECT',
  description: '',
  modules: [],
  actions: [],
}

export default scope
